import React, { useEffect, useState } from "react";
import { apiService, apiUtils } from "../services/apiService";
import {
  FaEnvelope,
  FaUser,
  FaEnvelopeOpen,
  FaTrash,
  FaClock,
} from "react-icons/fa";

const Msg = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await apiService.messages.getAll();
      setMessages(response.data);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await apiUtils.handleDelete(() => apiService.messages.delete(id), {
        successMessage: "Message deleted successfully!",
        errorMessage: "Failed to delete message",
        confirmMessage: "Are you sure you want to delete this message?",
        onSuccess: () => fetchMessages(),
      });
    } catch (error) {
      console.error("Error deleting message:", error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const isNewMessage = (dateString) => {
    const messageDate = new Date(dateString);
    const currentDate = new Date();
    const diffTime = currentDate - messageDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays <= 1;
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FaEnvelope className="text-white text-xl mr-3" />
              <h1 className="text-xl font-bold text-white">Messages</h1>
            </div>
            <div className="text-white text-sm">
              {messages.length} message{messages.length !== 1 ? "s" : ""}
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {isLoading ? (
          <div className="text-center py-12">
            <svg
              className="animate-spin h-8 w-8 text-indigo-600 mx-auto"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <p className="mt-2 text-gray-600">Loading messages...</p>
          </div>
        ) : messages.length === 0 ? (
          <div className="text-center py-12">
            <FaEnvelopeOpen className="text-gray-400 text-4xl mx-auto mb-4" />
            <p className="text-gray-600">No messages found</p>
          </div>
        ) : (
          messages.map((message) => (
            <div
              key={message._id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center">
                      <FaUser className="text-indigo-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">
                        {message.name}
                      </h3>
                      <p className="text-sm text-gray-500">{message.email}</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    {isNewMessage(message.datePosted) && (
                      <span className="bg-green-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                        New
                      </span>
                    )}
                    <button
                      onClick={() => handleDelete(message._id)}
                      className="text-red-500 hover:text-red-700 p-2 rounded-lg hover:bg-red-50 transition-colors"
                      title="Delete message"
                    >
                      <FaTrash size={16} />
                    </button>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <p className="text-gray-700 leading-relaxed">
                    {message.message}
                  </p>
                </div>

                <div className="flex items-center text-sm text-gray-500">
                  <FaClock className="mr-1" />
                  <span>{formatDate(message.datePosted)}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Msg;
